import React from "react";
import Layout from "./Layout";
import Navbar from "./Navbar";

type Props = {
  auth?: boolean;
  light?: boolean;
  full?: boolean;
  account?: boolean;
  children?: React.ReactNode;
};

const MainLayout: React.FC<Props> = ({ children, account }) => {
  return (
    <>
      <Navbar />
      <Layout account={account}>
        <div className="account">
          <div className="content">{children}</div>
        </div>
      </Layout>
      {/* <Footer /> */}
    </>
  );
};

export default MainLayout;
